import { Injectable } from "@angular/core";
import { EsDocument } from "@edp-models/ES/es-document.model";
import { FileEsService } from "@edp-services/ES/file-es.service";
import { EDocumentEsActions, GetDocumentEs, SetDocumentEs } from "@edp-store/actions/ES/document-es.actions";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { mergeMap, switchMap } from "rxjs/operators";

@Injectable()
export class EsDocumentEffects {
    @Effect()
    loadDocument$ = this.actions$.pipe(
        ofType(EDocumentEsActions.GetDocumentEs),
        switchMap((action: GetDocumentEs) =>
            this.fileEsService
                .getDocuments({ contract_id: action.contractId })
                .pipe(mergeMap((document: EsDocument[]) => of(new SetDocumentEs(document))))
        )
    );

    constructor(private actions$: Actions, private fileEsService: FileEsService) {}
}
